import { PRESUPUESTADOR_REMOVE_ENTREGA_USADO } from './constants'

export function removeEntregaUsado(auto) {
  return {
    type: PRESUPUESTADOR_REMOVE_ENTREGA_USADO,
    data: auto,
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_REMOVE_ENTREGA_USADO:
      if(action.data.patente){
        return {
          ...state,
          entregaUsados: state.entregaUsados.filter((usado) => usado.patente !== action.data.patente),
          Taking_cars: state.Taking_cars.filter((usado) => usado.license_plate !== action.data.patente),
          solicitudPendiente: { ...state.solicitudPendiente, [action.data.patente]: false }
        }
      } else {
        return {
          ...state,
          entregaUsados: state.entregaUsados.filter((usado) => (usado.quotation_id !== action.data.quotation_id) || usado.patente),
          Taking_cars: state.Taking_cars.filter((usado) => (usado.quotation_id !== action.data.quotation_id) || usado.license_plate),
        }
      }

    default:
      return state
  }
}
